// extracted by mini-css-extract-plugin
export var actions = "styles-module--actions--60b79";
export var container = "styles-module--container--e37a3";
export var header = "styles-module--header--8dd37";
export var logo = "styles-module--logo--aa751";
export var secondaryButton = "styles-module--secondaryButton--be19c";